define('views/modules/help/modals/contact-form-sending-message-modal',[
    // Libs
    'underscore',
    'backbone',
    'mustache',
    // views
    'views/parts/modal/modal'
], function (
    // Libs
    _, Backbone, Mustache,
    // views
    VModal
) {
    var VContactFormSengindMessageModal = VModal.extend({
        template: '<p class="text-center">{{modalMessage}}&nbsp;<span class="fa fa-spinner fa-pulse fa-1x fa-fw"></span></p>',

        modal: function () {
            return {
                closeButton: false,
                size: 'small',
                buttons: {},
            };
        },

        initialize: function(modalMessage) {
            this.modalMessage = modalMessage;
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext({
                modalMessage: this.modalMessage
            })));
            this.renderModal();
            return this;
        },
    });

    return VContactFormSengindMessageModal;
});

